/* Bedtextielonline (Claude, okt 2026): werking van de kleurbolletjes op de productkaarten.
   Stond vroeger als los scriptje in elke productkaart (36x per pagina); nu één keer, als bestand.
   - kies je een ander bolletje, dan gaan de links en de titel van de kaart mee naar die kleur
   - de knop +X haalt de verborgen kleuren pas op bij klik (sinds 23/10/2026, voor snelheid),
     zodat de server niet meer elke kleur van elk product vooraf moet opbouwen. */
(function () {
  if (window.__btolSiblingSwatch) return;
  window.__btolSiblingSwatch = true;

  function compact(m) {
    if (!m || !m.preview_image) return null;
    return JSON.stringify({
      alt: m.alt || '',
      preview_image: { src: m.preview_image.src, width: m.preview_image.width, height: m.preview_image.height }
    });
  }

  /* foto-info aanvullen voor bolletjes die ze nog niet hebben */
  function vulAan(card) {
    card.querySelectorAll('input[data-sibling-url]:not([data-variant-media])').forEach(function (input) {
      var url = (input.getAttribute('data-sibling-url') || '').split('?')[0];
      if (!url) return;
      fetch(url + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.media || !p.media.length) return;
          var eerste = compact(p.media[0]);
          var tweede = compact(p.media[1]);
          if (eerste) input.setAttribute('data-variant-media', eerste);
          if (tweede) input.setAttribute('data-variant-secondary-media', tweede);
        })
        .catch(function () {});
    });
  }

  /* foto's van alle kleuren van één kaart in één keer ophalen (23/10/2026).
     De server zet die info niet meer bij elk bolletje; we halen ze pas op als iemand bij de bolletjes komt. */
  var mediaCache = {};
  function laadMedia(card) {
    var handle = card.getAttribute('handle');
    if (!handle) return Promise.resolve();
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (!mediaCache[handle]) {
      mediaCache[handle] = fetch(root + 'products/' + handle + '?view=btol-kaartmedia', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : '{}'; })
        .then(function (txt) { try { return JSON.parse(txt); } catch (e) { return {}; } })
        .catch(function () { return {}; });
    }
    return mediaCache[handle].then(function (data) {
      card.querySelectorAll('input[data-sibling-url]:not([data-variant-media])').forEach(function (input) {
        var info = data[input.value];
        if (!info || !info.m) return;
        input.setAttribute('data-variant-media', JSON.stringify(info.m));
        if (info.s) input.setAttribute('data-variant-secondary-media', JSON.stringify(info.s));
      });
      // reservepad: wat nog ontbreekt via /products/<handle>.js
      if (!card.__btolVulAan && card.querySelector('input[data-sibling-url]:not([data-variant-media])')) { card.__btolVulAan = true; vulAan(card); }
    });
  }

  ['pointerover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var zone = event.target.closest && event.target.closest('product-card .product-card__info');
      if (!zone) return;
      var card = zone.closest('product-card');
      if (card && !card.__btolVulAan && card.querySelector('input[data-sibling-url]:not([data-variant-media])')) laadMedia(card);
    }, { passive: true, capture: true });
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('input[data-sibling-url]')) return;

    var card = input.closest('product-card');
    if (!card) return;

    if (!input.hasAttribute('data-variant-media') && !input.__btolOpnieuw) {
      input.__btolOpnieuw = true;
      laadMedia(card).then(function () {
        if (input.checked && input.hasAttribute('data-variant-media')) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    card.querySelectorAll('a.product-card__media, a.product-title').forEach(function (link) {
      link.setAttribute('href', input.getAttribute('data-sibling-url'));
    });

    var titleLink = card.querySelector('a.product-title');
    if (titleLink && input.getAttribute('data-sibling-title')) {
      titleLink.textContent = input.getAttribute('data-sibling-title');
    }

    var quickBuy = card.querySelector('.product-card__quick-add-button');
    if (quickBuy) {
      quickBuy.style.display = input.hasAttribute('data-sibling-current') ? '' : 'none';
    }
  });

  /* verborgen kleuren ophalen (23/10/2026): de kaart bouwt ze niet meer vooraf op,
     ze komen uit /products/<handle>?view=btol-kleuren (templates/product.btol-kleuren.liquid) */
  function haalKleurenOp(moreButton, card) {
    var url = moreButton.getAttribute('data-btol-kleuren-url');
    if (!url) return Promise.resolve();
    var bestaand = card.querySelector('input[data-sibling-url]');
    var groep = bestaand ? bestaand.getAttribute('name') : '';
    moreButton.setAttribute('aria-busy', 'true');
    moreButton.disabled = true;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim()) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        tmp.querySelectorAll('input[name]').forEach(function (input) {
          var oudeId = input.id;
          var sibId = input.value;
          if (groep) {
            input.setAttribute('name', groep);
            input.id = groep + '-' + sibId;
          }
          var label = tmp.querySelector('label[for="' + oudeId + '"]');
          if (label) label.setAttribute('for', input.id);
        });
        while (tmp.firstChild) moreButton.parentNode.insertBefore(tmp.firstChild, moreButton);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var moreButton = event.target.closest('.btol-swatch-more');
    if (!moreButton) return;

    event.preventDefault();

    var card = moreButton.closest('product-card');
    if (!card) return;

    card.querySelectorAll('.btol-swatch-hidden').forEach(function (el) {
      el.classList.remove('btol-swatch-hidden');
    });

    haalKleurenOp(moreButton, card).then(function () {
      laadMedia(card);
      moreButton.remove();
    });
  });

  /* 'Meer kleuren' in de zijlade 'Maak je bed compleet' en in de hoeslaken-/winkelwagensuggesties (23/10/2026):
     kleur 4 en verder staan niet meer vooraf in de pagina, ze komen uit /products/<handle>?view=btol-bu-kleuren
     of ?view=btol-cs-kleuren zodra iemand naar de knop gaat of erop klikt. Openklappen doet assets/btol-globaal.js. */
  function laadExtraKleuren(kl) {
    if (!kl || kl.__btolExtra) return kl && kl.__btolExtra;
    var url = kl.getAttribute('data-btol-kleuren-url');
    if (!url) return Promise.resolve();
    kl.__btolExtra = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim()) return;
        var meer = kl.querySelector('[data-btol-kleur-meer]');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        while (tmp.firstChild) kl.insertBefore(tmp.firstChild, meer || null);
        kl.removeAttribute('data-btol-kleuren-url');
      })
      .catch(function () { kl.__btolExtra = null; });
    return kl.__btolExtra;
  }
  ['pointerover', 'focusin', 'touchstart', 'click'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var meer = event.target.closest && event.target.closest('[data-btol-kleur-meer]');
      if (!meer) return;
      laadExtraKleuren(meer.closest('[data-btol-kleuren-url]'));
    }, { passive: true, capture: true });
  });
})();